import { Component } from '@nicolas-riciotti/light2';
import Lenis from '../../helpers/Lenis'
import getPosition from '../../helpers/getPosition';
import BezierEasing from '../../helpers/BezierEasing.js'
import Tween from '../../helpers/Tween.js';
import isMobile from '../../helpers/isMobile';


const easing = BezierEasing(.43,.195,.02,1);

export default class BlockHero extends Component {

    created() {
        this.onScroll = this.onScroll.bind(this); 
        this._scroll   = 0;
        this.numLines = 0;
        this.introProgresss = 0;
    }

    onScroll(e) {
        
        this._scroll = e.animatedScroll ;

        this.introScroll = 0;// (1 - this.introProgresss) * ((window.innerHeight ) );

        const delta = 0;//window.innerHeight/2;
        const diff = this._scroll - (this.$slides.length * window.innerHeight ) + delta;
        this.$blockGL.style.opacity = diff > 0 ? (1 - Math.min(1, Math.max(0, diff / (window.innerHeight/2)))) : 1;

        this.$slides?.forEach((slideEl, slideIndex) => {

            {
                let el = slideEl;
                let H = window.innerHeight;
                
                const scroll = Math.min(this.totalScrollHeight - H, this._scroll);

                const top = el._cachedTop ?? getPosition(el).top;
                let r = (top - scroll + H) / (window.innerHeight + H)
                r = Math.min(1, Math.max(0, r));
                const op = Math.max(0, scroll - top + window.innerHeight) / (window.innerHeight) ;
                let r2 = 0;
                if (op > 1) {
                    r2 = 1 - (op - 1);;
                }
                else {
                    r2 = op;
                }
                if (isMobile()) {
                    el.style.transform   = `none`;
                    el.querySelector('[data-slide-image]').style.opacity     = 1;
                    el.querySelector('[data-slide-image]').style.transform = `none`;
                }
                else {
                    // el.querySelector('[data-slide-content]').style.transform   = `translateY(${-top + scroll}px) translateZ(0)`;
                    el.querySelector('[data-slide-image]').style.transform     = `translateY(${-top + scroll}px) scale(${1 + r*.2}) translateZ(0)`;
                    el.querySelector('[data-slide-image]').style.opacity       = r2;
                    // el.querySelector('[data-slide-image]').style.filter       = `blur(${20 * (1-r2)}px)`;
                }
            }

            {
                const t       = slideEl._cachedTop ?? getPosition(slideEl).top;
                const centerY = (window.innerHeight/2);
                const delta   = (this._scroll - this.introScroll + window.innerHeight/2 - (t + centerY));
                const opacity = 1 -  Math.abs((delta * -1  ) / (window.innerHeight/2))
                slideEl.style.pointerEvents = opacity < 0 ? 'none' : 'auto';

                if (t - this._scroll + window.innerHeight/2 < window.innerHeight) {
                    this.$blockGL.setColors?.({
                        vignetteColor:   slideEl.getAttribute('data-vignette-color'),
                        backgroundColor: slideEl.getAttribute('data-background-color'),
                        outputColor:     slideEl.getAttribute('data-output-color'),
                    });
                }

                if (isMobile()) {
                    const op = 1 -  Math.max(0, Math.min(1, Math.abs((delta * -1  ) / (window.innerHeight/2))));
                    slideEl.style.removeProperty('transform');
                    slideEl.style.opacity  = 1//this.useMobileClass ? 1 : op;
                    const $words = slideEl.$normalText.querySelectorAll('[data-word]');
                    $words?.forEach((el) => {
                        slideEl.style.removeProperty('opacity');
                        slideEl.style.removeProperty('transform');
                    });
                    if (op  > 0) {
                        slideEl.classList.add('in-view');
                    }
                    else {
                        slideEl.classList.remove('in-view');
                    }
                    return
                }
                const op = 1 -  Math.max(0, Math.min(1, Math.abs((delta * -1  ) / (window.innerHeight*1.5/2))));

                const $words = slideEl.$normalText.querySelectorAll('[data-word]');
                $words?.forEach((el) => {
                    const lineIndex = Number(el.getAttribute('data-line-index'));
                    if (lineIndex == 0) {
                        if ( slideIndex < this.$slides?.length - 1  ) {
                            el.style.opacity   = 0;
                        }
                        else {
                            el.style.opacity   = 1;
                            let r, direction;
                            const delay = 0.1;
                            if (delta>0) {
                                direction = -1;
                                r = (op - delay * (slideEl.numLines - 1 - lineIndex)) / (1 - slideEl.numLines * delay);
                                r = Math.min(1, Math.max(0, r));
                                el.style.opacity   = r;
                                r = easing(r);
                                el.style.transform = `translateY(${(25 - r * 25) * direction}%) translateZ(0)`;
                            }
                        }
                        
                    }
                    else {
                        let r, direction;
                        const delay = 0.1;
                        if (delta>0) {
                            direction = -1;
                            r = (op - delay * (slideEl.numLines - 1 - lineIndex)) / (1 - slideEl.numLines * delay);
                        }
                        else {
                            direction = 1;
                            r = (op - delay * lineIndex) / (1 - slideEl.numLines * delay);
                        }
                        r = Math.min(1, Math.max(0, r));
                        el.style.opacity   = r;
                        r = easing(r);
                        el.style.transform = `translateY(${(25 - r * 25) * direction}%) translateZ(0)`;
                    }
                });


                const $static_word = slideEl.$normalText.querySelectorAll('[data-static-word]');
                $static_word?.forEach((el) => {

                });

            }
        });
        
    }

    nestedEach(node, cb){
        cb(node);
        node?.childNodes?.forEach(n => {
            this.nestedEach( n, cb );
        });
    }

    convertTextToMultilines(node) {
        const textNodes = [];
        this.nestedEach(node, (el) => {
            if (el.nodeType === 3 && el.textContent.trim() !== '') {
                textNodes.push(el);
            }
            if (el.nodeType !== 3 && el.tagName === 'BR') {
                const $wrappedBR = document.createElement('span'); 
                $wrappedBR.innerHTML = '<br/>';
                $wrappedBR.classList.add('desktop-break');
                el.parentNode?.replaceChild( $wrappedBR, el);
            }
        });

        textNodes.forEach((el) => {
            const words = el.textContent.trim().split(/\s+/);  
            const parent = el.parentNode;
            if (parent) {
                const fragment = document.createDocumentFragment(); 
                words.forEach((word, index) => {
                    const $outerSpan = document.createElement('span');
                    $outerSpan.setAttribute('data-word', '');
                    $outerSpan.style.transform = 'translateZ(0)';
                    $outerSpan.style.display   = 'inline-block';  
                    $outerSpan.style.position  = 'relative';  
                    $outerSpan.setAttribute('data-line-index', 0);
                    $outerSpan.setAttribute('data-word-index', 0);
                    $outerSpan.classList?.add('text-line');
                    $outerSpan.innerHTML     = word || ' ';  
                    fragment.appendChild($outerSpan);
                    if (index < words.length - 1) {
                        fragment.appendChild(document.createTextNode(' '));
                    }
                });
                parent.replaceChild(fragment, el);
            }
        });
    }

    attached() {

        this.$blockGL = this.querySelector('block-gl') ;

        this.$slides = this.querySelectorAll('[data-slide]') ;

        this.$slides?.forEach((slideEl, slideIndex) => {
            slideEl.$normalText = slideEl.querySelector('[normal-text]');
            this.convertTextToMultilines( slideEl.$normalText );
            if (slideIndex === 0) {
                this.$blockGL.vignetteColor   = slideEl.getAttribute('data-vignette-color');
                this.$blockGL.backgroundColor = slideEl.getAttribute('data-background-color');
                this.$blockGL.outputColor     = slideEl.getAttribute('data-output-color');
            }
        });

        Lenis?.on?.('scroll', this.onScroll)

        this.resize();

        Tween({e:0}, {
            to: {e:1},
            easing:    [0.43, 0.195, 0.02, 1],
            duration:  4000,
            step: e => {
                // this.introProgresss = e;
                // this.onScroll({animatedScroll:0});
            }
        });
        
    }
    resize() {

        this.totalScrollHeight = this.clientHeight

        // Cache slide top positions so onScroll doesn't re-measure layout per
        // tick (getPosition triggers reflow, multiplied by # slides every
        // Lenis frame = stutter).
        this.$slides?.forEach(slideEl => {
            slideEl._cachedTop = getPosition(slideEl).top;

            let currY     = -1;
            let lineIndex = -1;
            let wordIndex =  0;
            const $words  = slideEl.querySelectorAll('[data-word]');
            $words?.forEach( el => {
                const p = getPosition(el);
                if (p.top > currY) {
                    currY = p.top;
                    lineIndex++;
                    wordIndex = 0;
                }
                el.setAttribute('data-line-index', lineIndex);
                el.setAttribute('data-word-index', wordIndex);
                el.style.setProperty('--word-index', wordIndex);
                el.style.setProperty('--line-index', lineIndex);
            });
            slideEl.numLines = lineIndex + 1;
        });

    }



}

customElements.define('block-hero', BlockHero);